import { Table } from 'antd';
import React, { useEffect, useState } from 'react';

function ProductsList () {
    let [ mobile, setMobile ] = useState( false );

    useEffect( () => {
        window.scrollTo( 0, 0 );
        if ( document.getElementById( "root" ).clientWidth < 600 ) {
            setMobile( true );
        }
    }, [] );

    return (
        <div className='products-container'>
            <div className='products-banner'>
                {!mobile && <img src={require( "../../images/products/banner.avif" )} alt="product-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require( "../../images/products/banner-mobile.avif" )} alt="product-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>List of Products</span>
                    <span>Precision-engineered fasteners for secure, reliable, and high-performance applications in aerospace and beyond.</span>
                </div>
            </div>
            <div className='about-header'>
                AS, MS, NAS and variety of other series
            </div>
            <div className='product-table'>
                <Table columns={[
                    {
                        title: 'Parts Category',
                        dataIndex: 'category',
                        width: "40%",
                        className: "column1"
                    },
                    {
                        title: 'Item Description',
                        dataIndex: 'item',
                        width: "60%",
                        className: "column2"
                    },
                ]} dataSource={[
                    { key: '1', category: 'AS Parts', item: 'AS3504' },
                    { key: '2', category: 'AS Parts', item: 'AS3616' },
                    { key: '3', category: 'AS Parts', item: 'AS63285' },
                    { key: '3', category: 'AS Parts', item: 'AS48620' },
                    { key: '5', category: 'AS Parts', item: 'AS52760' },
                    { key: '6', category: 'AS Parts', item: 'AS52761' },
                    { key: '7', category: 'AS Parts', item: 'AS52762' },
                    { key: '8', category: 'AS Parts', item: 'AS52790' },
                    { key: '9', category: 'AS Parts', item: 'AS52791' },
                    { key: '10', category: 'AS Parts', item: 'AS52792' },
                    { key: '11', category: 'AS Parts', item: 'AS63281' },
                    { key: '12', category: 'AS Parts', item: 'AS63283' },
                    { key: '13', category: 'AS Parts', item: 'AS55932' },
                ].map( ( element ) => ( {
                    key: element.key,
                    category: element.category,
                    item: element.item,
                } ) )} pagination={false} width="100%" rowHoverable={false} />
                <Table columns={[
                    {
                        title: 'Parts Category',
                        dataIndex: 'category',
                        width: "40%",
                        className: "column1"
                    },
                    {
                        title: 'Item Description',
                        dataIndex: 'item',
                        width: "60%",
                        className: "column2"
                    },
                ]} dataSource={[
                    { key: '1', category: 'MS Parts', item: 'MS14144' },
                    { key: '2', category: 'MS Parts', item: 'MS14145' },
                    { key: '3', category: 'MS Parts', item: 'MS21084' },
                    { key: '4', category: 'MS Parts', item: 'MS21297' },
                    { key: '5', category: 'MS Parts', item: 'MS21299' },
                    { key: '6', category: 'MS Parts', item: 'MS51830' },
                    { key: '7', category: 'MS Parts', item: 'MS51991' },
                ].map( ( element ) => ( {
                    key: element.key,
                    category: element.category,
                    item: element.item,
                } ) )} pagination={false} width="100%" rowHoverable={false} />
                <Table columns={[
                    {
                        title: 'Parts Category',
                        dataIndex: 'category',
                        width: "40%",
                        className: "column1"
                    },
                    {
                        title: 'Item Description',
                        dataIndex: 'item',
                        width: "60%",
                        className: "column2"
                    },
                ]} dataSource={[
                    { key: '1', category: 'NAS Parts', item: 'NAS1101' },
                    { key: '2', category: 'NAS Parts', item: 'NAS1102' },
                    { key: '3', category: 'NAS Parts', item: 'NAS1141' },
                    { key: '4', category: 'NAS Parts', item: 'NAS1142' },
                    { key: '5', category: 'NAS Parts', item: 'NAS1160' },
                    { key: '6', category: 'NAS Parts', item: 'NAS1351' },
                    { key: '7', category: 'NAS Parts', item: 'NAS1352' },
                    { key: '8', category: 'NAS Parts', item: 'NAS1423' },
                    { key: '9', category: 'NAS Parts', item: 'NAS1726' },
                    { key: '10', category: 'NAS Parts', item: 'NAS1802' },
                    { key: '11', category: 'NAS Parts', item: 'NAS1802' },
                    { key: '12', category: 'NAS Parts', item: 'NAS1960' },
                    { key: '13', category: 'NAS Parts', item: 'NAS509' },
                    { key: '14', category: 'NAS Parts', item: 'NAS5310' },
                    { key: '15', category: 'NAS Parts', item: 'NAS6703' },
                    { key: '16', category: 'NAS Parts', item: 'NAS6704' },
                    { key: '17', category: 'NAS Parts', item: 'NAS6705' },
                    { key: '18', category: 'NAS Parts', item: 'NAS6706' },
                    { key: '19', category: 'NAS Parts', item: 'NAS6707' },
                    { key: '20', category: 'NAS Parts', item: 'NAS6708' },
                    { key: '21', category: 'NAS Parts', item: 'NAS6709' },
                    { key: '22', category: 'NAS Parts', item: 'NAS6710' },
                    { key: '23', category: 'NAS Parts', item: 'NAS6711' },
                    { key: '24', category: 'NAS Parts', item: 'NAS6712' },
                    { key: '25', category: 'NAS Parts', item: 'NAS6713' },
                    { key: '26', category: 'NAS Parts', item: 'NAS6714' },
                    { key: '27', category: 'NAS Parts', item: 'NAS6715' },
                    { key: '28', category: 'NAS Parts', item: 'NAS6716' },
                    { key: '29', category: 'NAS Parts', item: 'NAS6717' },
                    { key: '30', category: 'NAS Parts', item: 'NAS6718' },
                    { key: '31', category: 'NAS Parts', item: 'NAS6719' },
                    { key: '32', category: 'NAS Parts', item: 'NAS6710' },
                    { key: '33', category: 'NAS Parts', item: 'NAS77' },
                ].map( ( element ) => ( {
                    key: element.key,
                    category: element.category,
                    item: element.item,
                } ) )} pagination={false} width="100%" rowHoverable={false} />
            </div>
        </div>
    )
}

export default ProductsList
